<template>
  <div>
    <my-list
      ref="log"
      config="store/mall/log.js"
      @search="searchData"
    >
    </my-list>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sid: 0,
    };
  },
  methods: {
    init(sid) {
      this.sid = sid;
      this.$refs.log.search();
    },
    searchData(data, resolve) {
      if (this.sid == 0) {
        resolve({
          Count: 0,
          List: [],
        });
        return;
      }
      data.sid = this.sid;
      this.$api.mall
        .Log(data)
        .then(resolve)
        .catch((res) => {});
    },
  },
};
</script>